import { sendMotionEvent, queryGrayTest, isSSAI } from './utils.js'
var SYS_KEY_NAMES = ['home', 'recent_app', 'screen_off']
var SYS_KEY_EVENTS_MAP = {
    "home": 'PAD_HOME',
    "recent_app": 'PAD_MENU',
    "screen_off": 'PAD_LOCK_SCREEN'
}
var $_chat = {
    host:null,
    port:null,
    callback:null,
    socket:null,
    messageCallbackList:[],
    agent:null,
    timer: null,
    timerCalc: 0,
    isPadPageHide: false, // 是否是系统键导致的隐藏
    //初始化请求
    init:function(host,port,connMsg,callback){
        $_chat.host = host;
        $_chat.port = port;
        $_chat.connMsg = connMsg;
        $_chat.callback = callback;
        //获取浏览器
        $_chat.agent = $_chat.getUserAgent();
        //链接CHAT服务器
        if(!$_chat.socket){
            $_chat.linkChat();
        }
        // 用户操作home键、菜单键、电源键息屏或自动息屏时，需要关闭socket长连接，且不重试
        const isExistPadSysKeyFunc = !window.onPressSysKey4Monitor && isSSAI();
        isExistPadSysKeyFunc && $_chat.initSysKey4Monitor();
    },
    //执行链接监听
    linkChat:function(){
        $_chat.connentChat(function(){
            //监听链接错误
            $_chat.onError();
            //监听链接是否成功并发送链接信息
            $_chat.onConnent();
            //监听链接是否断开
            $_chat.onClose();
            //监听接收到的信息
            $_chat.onMessage(function(message){
                if($_chat.callback){
                    $_chat.callback(message);
                }
            });
            //监听接收到的心跳
             $_chat.onKeepalive(function(message){
                if($_chat.callback){
                    $_chat.callback(message);
                }
             });
            //监听系统通知
            $_chat.onSystemMessage(function(message){
                if($_chat.callback){
                    $_chat.callback(message);
                }
            });
            //监听系统错误
            $_chat.onSystemError(function(message){
                if($_chat.callback){
                    $_chat.callback(message);
                }
            });
        });
    },
    //关闭一个链接
    closeChat: function () {
        $_chat.offClose();
        $_chat.socket.disconnect();
        $_chat.socket = null;
    },
    //调用Pad端系统键回调
    initSysKey4Monitor:function(){
        var that = this;
        // 操作系统键时会断掉长连接的钩子函数，在spadBack组件中调用函数
        window.onPressSysKey4Monitor = (type) => {
            var socketMsg = $_chat.connMsg;
            if (SYS_KEY_NAMES.includes(type)) {
                if (!$_chat.socket) return;
                // 发送新的事件：PAD_LOCK_SCREEN、PAD_HOME、PAD_MENU
                socketMsg = Object.assign({}, socketMsg, { event: SYS_KEY_EVENTS_MAP[type] });
                $_chat.sendMessage(socketMsg);
                $_chat.closeChat();
                $_chat.isPadPageHide = true;
                window.stopStudyTime && window.stopStudyTime();
                if ($_chat.timer) {
                    clearInterval($_chat.timer);
                    $_chat.timer = null;
                    $_chat.timerCalc = 0;
                }
            }
        }
        // 从后台回到前台时，要恢复长链接
        if (!window.onShowPage) {
            window.onShowPage = () => {
                that.recoverChat();
            }
        }
        // 恢复长连接的钩子函数，在winterPk组件中调用函数
        window.onRecoverChat4Monitor = () => {
            that.recoverChat();
        }
    },
    // 当学习系统回到前台时，重新连接长连接
    recoverChat: function(callback){
        if ($_chat.isPadPageHide && !$_chat.socket) {
            $_chat.linkChat();
            $_chat.isPadPageHide = false;
            setTimeout(() => {
                callback && callback();
            }, 500);
            window.continueStudyTime && window.continueStudyTime();
        } else {
            callback && callback();
        }
    },
    //获取浏览器
    getUserAgent:function(){
        var agent = '';
        if (/Firefox/i.test(navigator.userAgent)){
            agent = 'Firefox';
        }else if(/MSIE (\d+.\d+);/.test(navigator.userAgent)){
            agent = 'IE';
        }else{
            agent = '';
        }
        return agent;
    },
    //链接聊天服务器
    connentChat:function(callback){
        if(!$_chat.host || !$_chat.port){
            return false;
        }
        if($_chat.socket) {
            return false;
        }
        $_chat.socket = io.connect($_chat.host+':'+$_chat.port,{'connect timeout':5000,'reconnect':true,'max reconnection attempts':5,'reconnection limit':50,'transports':['websocket','polling']});
        if(callback){
            callback();
        }
        return;
    },
    //监听链接
    onConnent:function(){
        $_chat.socket.on('connect',function(){
            //发送用户链接信息
            console.log('connected');
            $_chat.socket.emit('init',$_chat.connMsg);
            sendMotionEvent('LOGIN', $_chat.connMsg);
        });
    },
    disconnectListener:function(){
        console.log('disconnected');
        if ($_chat.timerCalc < 5) {
            $_chat.closeChat();
        }
        if ($_chat.timer) {
            clearInterval($_chat.timer);
        }
        $_chat.timer = setInterval(() => {
            if ($_chat.timerCalc < 5 && !$_chat.socket) {
            $_chat.timerCalc++;
            console.log('try to reconnect, time:' + $_chat.timerCalc);
            setTimeout(function () {
                $_chat.linkChat();
            }, 500);
            } else {
            clearInterval($_chat.timer);
            }
        }, 3000);
    },
    //监听连接断开
    onClose:function(){
        $_chat.socket.on('disconnect', $_chat.disconnectListener);
    },
    //移除监听连接断开
    offClose:function(){
        $_chat.socket.off('disconnect', $_chat.disconnectListener);
    },
    //监听链接错误
    onError:function(){
        $_chat.socket.on('error',function(reason){
            console.log('error', reason);
        });
    },
    //监听系统通知
    onSystemMessage:function(callback){
        $_chat.socket.on('SYSTEM_MESSAGE',function(message){
            console.log('system message:', message);
            if($_chat.agent == 'IE'){
                setTimeout(callback(message),100);
            }else{
                callback(message);
            }
        });
    },
    //监听系统错误
    onSystemError:function(callback){
        $_chat.socket.on('ERROR',function(message){
            console.log('system error:', message);
            if($_chat.agent == 'IE'){
                setTimeout(callback(message),100);
            }else{
                callback(message);
            }
        });
    },
    //监听接受到的信息
    onMessage:function(callback){
        if($_chat.messageCallbackList.toString().indexOf(callback.toString()) == -1){
            $_chat.messageCallbackList.push(callback)
        }
        // 先移除事件监听器
        if ($_chat.socket) {
            $_chat.socket.off('message', $_chat.onMessageCallBack);
            $_chat.socket.on('message', $_chat.onMessageCallBack);
        }
    },
    onMessageCallBack:function(message){
        console.log('recv:', message);
        sessionStorage.setItem("teacherId", message.teacher_id || -1);
        if($_chat.agent == 'IE'){
            setTimeout(()=>{
                //callback(message)
                $_chat.messageCallbackList.map((fun)=>{
                    fun(message)
                })
            },100);
        }else{
            //callback(message);
            $_chat.messageCallbackList.map((fun)=>{
                fun(message)
            })
        }
    },
    //监听心跳
    onKeepalive: function (callback) {
        $_chat.socket.on('keepalive',function(message){
            console.log('recv:', message);
            if($_chat.agent == 'IE'){
                setTimeout(callback(message),100);
            }else{
                callback(message);
            }
        });
    },
    //发送一条信息
    sendMessage:function(data){
        if($_chat.socket){
            console.log('send:', data);
            $_chat.socket.emit('message',data);
        } else {
            console.log('fail to send, disconnected from server', data);
        }
    },
    //发送一条心跳
    sendKeepalive:function(data){
        if($_chat.socket) {
            console.log('send:', data);
            $_chat.socket.emit('keepalive', data);
        } else {
            console.log('fail to send, disconnected from server', data);
        }
    }

}

export default $_chat
